import React from 'react';
import { MarkerF } from '@react-google-maps/api';

export const UserLocationMarker = ({ position, hasSignal, isLocked }) => {
  if (!position) return null;

  // Create pulsing marker icon
  const svg = `
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="${isLocked ? '#3B82F6' : '#6B7280'}" opacity="0.2" />
      <circle cx="12" cy="12" r="8" fill="${hasSignal ? '#3B82F6' : '#EF4444'}" stroke="white" stroke-width="2">
        <animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite" />
      </circle>
    </svg>
  `;

  return (
    <MarkerF
      position={position}
      icon={{
        url: `data:image/svg+xml;base64,${btoa(svg)}`,
        scaledSize: new google.maps.Size(24, 24),
        anchor: new google.maps.Point(12, 12)
      }}
      zIndex={1000}
    />
  );
};